import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import { VueEditor } from 'vue2-editor'
import Editor from '@tinymce/tinymce-vue'
import AceEditor from 'vuejs-ace-editor'

export default {
  name: 'BlogPostForm',
  computed,
  data,
  methods,
  mounted,
  watch,
  components: {
    VueEditor,
    editor: Editor,
    AceEditor,
  },
}
